import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { SlotComponent } from '../slot.component';
import { SlotTooltipPipe, TranslationKeyPipe, DelayDisplayImpurePipe } from '../../../pipes';
import { LayoutDirective } from '../../../directives';
import { ComponentsModule, slideDown } from '../../../../../lib';
import { VisualComponent } from '../../visual/visual.component';

@Component({
    selector: 'ca-slot-inline-radio-button',
    templateUrl: './slot-inline-radio-button.component.html',
    styleUrls: ['./slot-inline-radio-button.component.scss'],
    imports: [
        CommonModule,
        LayoutDirective,
        MatRadioModule,
        TranslationKeyPipe,
        SlotTooltipPipe,
        DelayDisplayImpurePipe,
        ComponentsModule,
        VisualComponent
    ],
    animations: [slideDown],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotInlineRadioButtonComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlotInlineRadioButtonComponent extends SlotComponent {
    ariaLabel = input<string>('');

    override writeValue(value: any): void {
        this.value.set(value);
    }

    onValueChange(value: any) {
        if (!this.isDisabled) {
            this.value.set(value);
            this.onChange(value);
        }
    }

    /**
     * Allows clearing the selection of an optional radio slot by clicking the already selected option.
     * A native radio group cannot be deselected, so a click on the current value resets it to null.
     * When the click originates from the label, the default action is prevented so the label does not
     * immediately re-select the input. For direct input (circle) clicks preventing the default would
     * keep the native input visually checked, so it must not be prevented there.
     */
    onRadioClick(value: any, event: Event, preventReselect = false) {
        if (this.isDisabled || !this.isOptional || this.value() !== value) {
            return;
        }
        if (preventReselect) {
            event.preventDefault();
        }
        this.value.set(null);
        this.control.setValue(null);
        this.onChange(null);
    }
}
